import "./CompanySelector.scss";
import React, { useEffect, useMemo } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import * as UserRedux from "../redux/user";
import { TEST_COMPANIES } from "@blisspointmedia/bpm-types/dist/TestCompanies";
import * as R from "ramda";
import { MdSearch } from "react-icons/md";
import * as uuid from "uuid";
import { Link } from "react-router-dom";
import { Location } from "../utils/hooks/useLocation";

export interface CompanySelectorProps {
  expanded?: boolean;
  location?: Location;
  pageToTravelTo?: string;
  closeNavBar?: () => void;
  setPageToTravelTo?: (page: string) => void;
  navBar: boolean;
  company: string;
  setCompany:
    | React.Dispatch<React.SetStateAction<string>>
    | ((company: string) => void);
  newCompanySelector?: boolean;
  setNewCompanySelector?: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >;
  companySearchQuery: string;
  setCompanySearchQuery: React.Dispatch<React.SetStateAction<string>>;
}

export const CompanySelector = ({
  expanded,
  location,
  pageToTravelTo,
  closeNavBar = () => {},
  setPageToTravelTo = () => {},
  navBar,
  company,
  setCompany = () => {},
  newCompanySelector,
  setNewCompanySelector = () => {},
  companySearchQuery,
  setCompanySearchQuery = () => {},
}: CompanySelectorProps): JSX.Element => {
  const allUserCompanies = useSelector(UserRedux.companiesSelector);
  const companies: { company: string; role: number }[] = useMemo(
    () =>
      R.filter(
        (company) => !TEST_COMPANIES.includes(company.company),
        R.defaultTo([], allUserCompanies)
      ),
    [allUserCompanies]
  );

  const filteredCompanies = useMemo(
    () =>
      R.filter(
        (company: any) =>
          company.company.includes(companySearchQuery.trim().toLowerCase()),
        companies
      ),
    [companies, companySearchQuery]
  );

  useEffect(() => {
    if (!R.isNil(newCompanySelector) && newCompanySelector === false) {
      setNewCompanySelector(undefined);
      setCompanySearchQuery("");
    }
  }, [newCompanySelector, setCompanySearchQuery, setNewCompanySelector]);

  return (
    <div className="companySelector" id="companySelector">
      {companies && companies.length > 7 && (
        <div className="companySelectorSearchBar">
          <div
            className="pageSearchIcon"
            onClick={() => {
              while (expanded === false && navBar) {
                const searchBar = document.getElementById("companySearchInput");
                if (searchBar) {
                  searchBar.focus();
                }
              }
              const searchBar = document.getElementById("companySearchInput");
              if (searchBar) {
                searchBar.focus();
              }
            }}
          >
            <MdSearch className="pageSearchIcon" />
          </div>
          <Form.Control
            className="companySearchInput"
            id="companySearchInput"
            onChange={(e) => {
              setCompanySearchQuery(e.target.value);
            }}
            placeholder="Search Clients"
            value={companySearchQuery}
          />
        </div>
      )}
      <div className="companySelectorTitle">Pick a client</div>
      <div className="companySelectorRows">
        {filteredCompanies.length === 0 && (
          <div
            className="companySelectorRow"
            style={{ cursor: "default", height: "64px" }}
          >
            No search results found for "{companySearchQuery}"
          </div>
        )}
        {filteredCompanies.length !== 0 &&
          navBar &&
          R.map(
            (companyRow: any) =>
              (company && location?.pathname.includes(company)) ||
              pageToTravelTo ? (
                <Link
                  key={companyRow.company}
                  className="companySelectorRow"
                  onClick={() => {
                    closeNavBar();
                    setCompany(companyRow.company);
                    setCompanySearchQuery("");
                  }}
                  to={
                    pageToTravelTo
                      ? pageToTravelTo.replace("{company}", companyRow.company)
                      : location?.pathname.replace(
                          company,
                          companyRow.company
                        ) ?? ""
                  }
                >
                  {`${companyRow.company}`}
                </Link>
              ) : (
                <div
                  id={uuid.v4()}
                  className="companySelectorRow"
                  onClick={() => {
                    setCompany(companyRow.company);
                    setCompanySearchQuery("");
                    setNewCompanySelector(false);
                    setPageToTravelTo("");
                  }}
                >
                  {`${companyRow.company}`}
                </div>
              ),
            filteredCompanies
          )}
        {filteredCompanies.length !== 0 &&
          !navBar &&
          R.map(
            (companyRow: any) => (
              <div
                id={uuid.v4()}
                className="companySelectorRow"
                onClick={() => {
                  setCompany(companyRow.company);
                  setCompanySearchQuery("");
                  setNewCompanySelector(false);
                }}
              >
                {`${companyRow.company}`}
              </div>
            ),
            filteredCompanies
          )}
      </div>
      <div className="cancelContainer">
        <div
          className="cancelButton"
          onClick={() => setNewCompanySelector(false)}
        >
          Cancel
        </div>
      </div>
    </div>
  );
};
